import React, { FC } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

const AVATAR_COLORS = ["#2D8CFF", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#F06449", "#6B7280"];

const hashName = (name: string): number => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + hash * 31;
  }
  return Math.abs(hash);
};

export const getAdvertiserAvatarColor = (name: string): string => {
  return AVATAR_COLORS[hashName(name) % AVATAR_COLORS.length];
};

const getAdvertiserAvatarColorIndex = (name: string): number => {
  return hashName(name) % AVATAR_COLORS.length;
};

type AdvertiserAvatarProps = {
  name: string;
};

const Avatar = styled("div")(({ theme }: { theme: Theme }) => ({
  width: 36,
  height: 36,
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  flexShrink: 0,
  '&[data-color="0"]': { background: "#2D8CFF18", color: "#2D8CFF" },
  '&[data-color="1"]': { background: "#10B98118", color: theme.palette.brand.green },
  '&[data-color="2"]': { background: "#F59E0B18", color: "#F59E0B" },
  '&[data-color="3"]': { background: "#EF444418", color: theme.palette.brand.errorRed },
  '&[data-color="4"]': { background: "#8B5CF618", color: "#8B5CF6" },
  '&[data-color="5"]': { background: "#F0644918", color: theme.palette.brand.coral },
  '&[data-color="6"]': { background: "#6B728018", color: theme.palette.brand.gray500 },
}));

const AdvertiserAvatar: FC<AdvertiserAvatarProps> = ({ name }) => {
  const initial = name.trim().charAt(0).toUpperCase() || "?";
  const colorIndex = getAdvertiserAvatarColorIndex(name);

  return <Avatar data-color={String(colorIndex)}>{initial}</Avatar>;
};

export default AdvertiserAvatar;
